import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phoneNumber = "33695442788"; // Format international sans le +
  const message = encodeURIComponent("Bonjour MY VITREO, je souhaite des informations sur vos services.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      aria-label="Contacter sur WhatsApp"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
}
